import React from 'react';
import HelperText from '../FormElements/HelperText';
import 'select2';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';

export default class AccountsSelectbox extends React.Component {
	constructor(props) {
		super(props);

		this.selectRef = React.createRef();
	}

	componentDidMount() {
		var self = this;

		$(this.selectRef.current).select2({
			ajax: {
				url: self.props.accounts_list_endpoint,
				dataType: 'json',
				data: function(params) {
					return {
						query: $(self.selectRef.current)
							.data('select2')
							.dropdown.$search.val(),
						sort_column: 'name',
						sort_order: 'asc',
						page: params.page,
						results_per_page: 10,
						api_key: self.props.account_crud_api_key
					};
				},
				delay: 250,
				processResults: function(response, params) {
					const results = response.data.map((element) => {
						return { id: element.id, text: element.name };
					});
					return {
						results: results,
						page: params.page,
						pagination: {
							more: response.meta.page < response.meta.total_pages
						}
					};
				}
			},
			allowClear: true,
			createTag: function(tag) {
				return {
					id: tag.term,
					text: tag.term,
					isNew: true
				};
			},
			language: {
				searching: function() {
					return I18n.t('loading');
				}
			},
			placeholder: self.props.placeholder,
			tags: false
		});

		$(this.selectRef.current).on('select2:close', function(e) {
			if (typeof self.props.onChange === 'function') {
				self.props.onChange($(self.selectRef.current).select2('data')[0] || {});
			}
		});
	}

	render() {
		// console.log(
		// 	'AccountsSelectbox - Props',
		// 	this.props,
		// 	'AccountsSelectbox - State',
		// 	this.state
		// );
		const {
			name,
			fieldErrors = [],
			helperText = null,
			onChange = () => {}
		} = this.props;

		return (
			<div className="row">
				<div className="col-sm-12">
					<select
						className="w-100"
						ref={this.selectRef}
						name={name}
						onChange={onChange}
						style={{ textAlign: 'left' }}
					/>
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : helperText ? (
						<HelperText>{helperText}</HelperText>
					) : null}
				</div>
			</div>
		);
	}
}
